export default __webpack_public_path__ + "static/media/step3-icon.748822cb.svg";